module.exports = __webpack_public_path__ + "img/mindmethod-star.0b8e4071.png";